// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"style__fullscreen__Jxejw"};